module.exports = __webpack_public_path__ + "img/dance-test-icon9.9bd0e1a6.png";